import Vue from "vue";
import VueRouter from "vue-router";

import Home from "../views/Home/Home.vue";

import Islands from "../views/Islands/Islands.vue";
import areaRoutes from "./area.js";

import MyLocation from "@/views/Location/MyLocation.vue";

import Pois from "../views/Pois/Pois.vue";
import Poi from "../views/Pois/Poi.vue";
import PoiCategories from "../views/Pois/Categories.vue";

import Routes from "../views/Routes/Routes.vue";
import Route from "../views/Routes/Route.vue";
import RouteCategories from "../views/Routes/Categories.vue";

import Events from "../views/Events/Events.vue";
import Event from "../views/Events/Event.vue";

import Settings from "../views/Settings/Settings.vue";

import TermsAndPolicies from "../views/Settings/TermsAndPolicies.vue";
import About from "../views/Settings/About.vue";
import Contact from "../views/Settings/Contact.vue";

import Login from "../views/Auth/Login.vue";
import Register from "../views/Auth/Register.vue";
import ResetPassword from "../views/Auth/ResetPassword.vue";
import ChangePassword from "../views/Auth/ChangePassword.vue";

import VisitedPlaces from "../views/VisitedPlaces/VisitedPlaces.vue";
import ParkingMap from "../components/ParkingMap.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Home,
  },

  {
    path: "/islands",
    component: Islands,
  },

  {
    path: "/parking",
    component: ParkingMap,
  },

  {
    path: "/my_location",
    component: MyLocation,
  },

  {
    path: "/pois",
    component: PoiCategories,
    props: { next_link: "/pois/results", locale: "pois" },
  },

  {
    path: "/pois/results",
    component: Pois,
  },

  {
    path: "/pois/results/:poi_id",
    component: Poi,
  },

  {
    path: "/routes",
    component: RouteCategories,
    props: { next_link: "/routes/results", locale: "routes" },
  },

  {
    path: "/events",
    component: Events,
  },
  {
    path: "/events/:event_id",
    component: Event,
  },

  {
    path: "/routes/results",
    component: Routes,
  },

  {
    path: "/routes/results/:route_id",
    component: Route,
  },

  {
    path: "/visited_places",
    component: VisitedPlaces,
  },

  {
    path: "/settings/terms_and_policies",
    component: TermsAndPolicies,
  },

  {
    path: "/settings/about",
    component: About,
  },

  {
    path: "/settings",
    component: Settings,
  },

  {
    path: "/settings/contact",
    component: Contact,
  },

  {
    path: "/login",
    component: Login,
  },

  {
    path: "/register",
    component: Register,
  },

  {
    path: "/reset_password",
    component: ResetPassword,
  },

  {
    path: "/change_password/:token",
    component: ChangePassword,
  },

  ...areaRoutes,
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    if (err.name != "NavigationDuplicated") {
      throw err;
    }
  });
};

export default router;
